import { useTranslation } from 'react-i18next';
import MarketingDataGrid from './marketing-data-grid/marketing-data-grid.component';
import MarketingSummaryHeader from './marketing-summary-header/marketing-summary-header.component';
import { useLazyExportMarketingSMSProgramsReportQuery } from 'api/sms-reports-service/sms-reports-service';
import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useSearchParamsContext } from 'components/search/search.hooks';
import { getClientAlias } from 'util/client-alias';
import SearchToolbar from 'components/search/search-toolbar/search-toolbar.component';
import ExportButton from '../../export-button/export-button.component';
import IncPageBody from 'components/inc-page/inc-page-body/inc-page-body.component';
import { DateTime } from 'luxon';
import { useSMSTotalsSearch } from '../../sms-reports-landing/sms-reports-search/sms-reports-search.hooks';
import { downloadCSV } from 'util/download-csv.utils';
import { Box } from '@mui/material';

const Marketing = () => {
  const { t } = useTranslation();

  const { enqueueSnackbar } = useSnackbar();
  const [isExporting, setIsExporting] = useState(false);

  const { refetchSMSTotals } = useSMSTotalsSearch('MARKETING');

  const { searchParams } = useSearchParamsContext();
  const [exportMarketingQuery] = useLazyExportMarketingSMSProgramsReportQuery();

  const exportReportFunction = async () => {
    setIsExporting(true);
    try {
      const { data: csvData } = await exportMarketingQuery({
        startDate: searchParams.startDate.value,
        endDate: searchParams.endDate.value,
        page: searchParams.page.value,
        count: searchParams.count.value,
        sortBy: searchParams.sortBy.value,
        sortDirection: searchParams.sortDirection.value,
      });

      downloadCSV(
        csvData,
        `${getClientAlias()}_Marketing_SMS_${DateTime.local().toFormat(
          'yyyy_MM_dd__HH_mm_ss',
        )}`,
      );
      enqueueSnackbar(
        t(
          'page.reportAndAnalytics.smsReports.sections.marketing.toast.success',
        ),
        { severity: 'success' },
      );
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <IncPageBody>
      <SearchToolbar
        buttons={
          <ExportButton
            exportReportFunction={exportReportFunction}
            isAdditionalLoading={isExporting}
          />
        }
        excludedFilters={['storeIds']}
        onRefreshClick={refetchSMSTotals}
      />
      <Box mt={2}>
        <MarketingSummaryHeader />
        <MarketingDataGrid />
      </Box>
    </IncPageBody>
  );
};

export default Marketing;
